import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sandboxMode: {
    defaultMessage: 'Sandbox mode',
    id: 'DemobankScenarioPicker.sandboxMode',
  },
  selectTestScenario: {
    defaultMessage: 'Select test scenario',
    id: 'DemobankScenarioPicker.selectTestScenario',
  },
});
